import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { QueryParams } from 'src/app/shared/constant';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { SrcExaminfInputService } from '../scr-exam-inf-input/scr-exam-inf-input.service';

@Component({
  selector: 'app-scr-exam-inf-input',
  templateUrl: './scr-exam-inf-input.component.html',
  styleUrls: ['./scr-exam-inf-input.component.scss']
})
export class ScrExamInfInputComponent implements OnInit {
  HTOrgName: string;
  HTOrgCode: string;
  ReceptDay: string;
  isReceptDay = false;
  ConSulNum: string;
  isConSulNum = false;
  ConSulID: string;
  isConSulID = false;
  DateOfBirth: string;
  isDateOfBirth = false;
  messErr: string;
  messErr2: string;
  messErr3: string;
  messErr4: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private loadingSrv: LoadingService,
    public util: Utility,
    private dialogModalService: DialogModalService,
    private translate: TranslateService,
    private router: Router,
    private auth: SrcExaminfInputService,
    private routeActived: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.util.addPerfectScrollBar();
    this.util.resetZoomBrowser();
    this.GetHTorgCode();
  }
  GetHTorgCode() {
    const strKey = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    if (!this.util.isNullOrEmpty(strKey)) {
      this.loadingSrv.setDisplay(true);
      this.auth.GetHTOrgCode(strKey).subscribe(data => {
        this.loadingSrv.setDisplay(false);
        if (data !== null) {
          this.HTOrgName = data.HTOrgName;
          this.HTOrgCode = data.HTOrgCode;
        } else {
          this.router.navigateByUrl('404');
        }
      }, err => {
        this.loadingSrv.setDisplay(false);
      });
    } else {
      this.router.navigateByUrl('404');
    }
  }
  inputValidate() {
    this.isReceptDay = false;
    this.isConSulNum = false;
    this.isConSulID = false;
    this.isDateOfBirth = false;
    let isValidate = false;
    if (this.util.isNullOrEmpty(this.ReceptDay)) {
      this.isReceptDay = true;
      this.messErr = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_RECEPT_DAY'));
      isValidate = true;
    }
    else {
      this.isReceptDay = false;
    }
    if (this.util.isNullOrEmpty(this.ConSulNum)) {
      this.isConSulNum = true;
      this.messErr2 = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_CONSULT_NUM'));
      isValidate = true;
    }
    else {
      this.isConSulNum = false;
    }
    if (this.util.isNullOrEmpty(this.ConSulID)) {
      this.isConSulID = true;
      this.messErr3 = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_CONSULT_ID'));
      isValidate = true;
    }
    else {
      this.isConSulID = false;
    }
    if (this.util.isNullOrEmpty(this.DateOfBirth)) {
      this.isDateOfBirth = true;
      this.messErr4 = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_DATEOFBIRTH'));
      isValidate = true;
    }
    else {
      this.isDateOfBirth = false;
    }
    return isValidate;
  }
  submit() {
    if (this.inputValidate()) {
      return;
    }
    const param = {
      HTOrgCode: this.HTOrgCode?.trim(),
      ConsulDay: this.ReceptDay?.trim(),
      ConsulNum: this.ConSulNum?.trim(),
      ConsulID: this.ConSulID?.trim(),
      DateOfBirth: this.DateOfBirth?.trim(),
    };
    this.loadingSrv.setDisplay(true);
    this.auth.CheckInfo(param).subscribe(data => {
      this.loadingSrv.setDisplay(false);

      if (data === 'A') {
        this.dialogModalService.openErrorModal(this.translate.instant('MESS_ERR_EXMINF_NOT_MATCH'));
      }

      if (data === 'D') {
        this.dialogModalService.openErrorModal(this.translate.instant('MESS_CNF_EXMINF_LINK_OTHER_USERINF'));
      }

      if (data === 'B') {
        const strKey = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
        const ConsulId =  this.ConSulID?.trim();
        const ConsulDay = this.ReceptDay?.trim();
        const ConsulNum = this.ConSulNum?.trim();
        const DateOfBirth = this.DateOfBirth?.trim();
        if (!this.util.isNullOrEmpty(strKey)) {
          sessionStorage.setItem('is0106', 'true');
          sessionStorage.setItem('id0106', this.ConSulID?.trim());
          sessionStorage.setItem('id0107', this.ReceptDay?.trim());
          sessionStorage.setItem('id0108', this.ConSulNum?.trim());
          sessionStorage.setItem('id0109', this.DateOfBirth?.trim());
          this.router.navigate(['sending-authen-mail'], {
            queryParams: {
              htorgcode: strKey,
              consulid: ConsulId,
              donsulDay: ConsulDay,
              consulNum: ConsulNum,
              dateOfBirth: DateOfBirth
            }
          });
        }
      }

      if (data.includes('C')) {
        
        sessionStorage.setItem('id0106', data.replace('C', ''));
        sessionStorage.setItem('consulID0106', this.ConSulID);        

        const strKey = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
        const ConsulId = this.ConSulID;
        if (!this.util.isNullOrEmpty(strKey)) {
          this.router.navigate(['src-exam-login'], {
            queryParams: {
              htorgcode: strKey,
              consulid: ConsulId,
              //sulid: this.ConSulID?.trim(),
            }
          });
        }else{
          this.router.navigateByUrl('src-exam-login');
        }
      }
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
  }
  removeErr(id: number) {
    if (id === 2) {
      if (!this.util.isNullOrEmpty(this.ConSulNum)){
        this.isConSulNum = false;
      }
    }
    else if (id === 3) {
      if (!this.util.isNullOrEmpty(this.ConSulID)){
        this.isConSulID = false;
      }
    }
  }
  ChangeDOB(pDate: string) {
    this.ReceptDay = this.util.ReplaceAll(pDate, '-', '');
    if (!this.util.isNullOrEmpty(this.ReceptDay)){
      this.isReceptDay = false;
    }
  }
  ChangeDOB1(pDate: string) {
    this.DateOfBirth = this.util.ReplaceAll(pDate, '-', '');
    if (!this.util.isNullOrEmpty(this.DateOfBirth)){
      this.isDateOfBirth = false;
    }
  }
  removeBoder(event: any) {
    this.DateOfBirth  = '';
  }
  removeBoder2(event: any) {
    this.ReceptDay = '';
  }
  RemoveCommon(id: string){
    if (id === 'DateOfBirth'){
      this.isDateOfBirth = false;
    }
    if (id === 'ReceptDay'){
      this.isReceptDay = false;
    }
  }
}
